import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Spin,
  message,
  Row,
  Col,
  DatePicker,
  Select,
} from "antd";

import { useDispatch, useSelector } from "react-redux";
import { LoadingConfig } from "../../../components";
import {
  InfoUserOrderAction,
  resetOrderAction,
  SearchOrderAction,
  UserLogin,
} from "../../../appRedux/action/OrderAction";
import moment from "moment";
import { useHistory } from "react-router-dom";

const { RangePicker } = DatePicker;

const FormSearch = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [captcha, setCaptcha] = useState(false);

  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("AUTH_INFO")) || ""
  );

  const vaccines = props.vaccines || [];

  // console.log(vaccines);
  const onFinish = async (values) => {
    // console.log(values);

    let newValue = {
      date_register_0:
        values && values.date ? moment(values.date[0]).unix() : null,
      date_register_1:
        values && values.date ? moment(values.date[1]).unix() : null,

      date_verify_0:
        values && values.date_verify
          ? moment(values.date_verify[0]).unix()
          : null,
      date_verify_1:
        values && values.date_verify
          ? moment(values.date_verify[1]).unix()
          : null,
      vaccine_id: values.vaccine_id,
      status: values.status_register,
    };
    // console.log("aaaa", newValue);
    await dispatch(SearchOrderAction(newValue));

    // const res = await dispatch(UserLogin(values));

    // if (res && res.code === "200") {
    //   message.success(res.message);
    //   history.push("/manage-register");
    // } else {
    //   message.error(res.message);
  };

  const handleReset = async () => {
    // dispatch(resetOrderAction());
    await dispatch(InfoUserOrderAction());
  };

  function onChange(value, dateString) {
    console.log("Selected Time: ", value);
    console.log("Formatted Selected Time: ", dateString);
  }

  function onOk(value) {
    console.log("onOk: ", value);
  }
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="formSearch">
      <div className="content__title--two">Thông tin người đăng ký</div>

      <Row gutter={16} className="formSearch__info">
        <Col className="gutter-row" md={12} sm={24}>
          Họ tên người đăng kí :
        </Col>
        <Col className="gutter-row" md={12} sm={24}>
          <b> {userInfo ? userInfo.name : ""}</b>
        </Col>
        <Col className="gutter-row" md={12} sm={24}>
          Số điện thoại : {userInfo ? userInfo.phone_number : ""}
        </Col>
        <Col className="gutter-row" md={12} sm={24}>
          Email: {userInfo ? userInfo.email : ""}
        </Col>
        <Col className="gutter-row" md={24} sm={24}>
          Địa chỉ: {userInfo ? userInfo.address : ""}
        </Col>
      </Row>
      <Form
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        className="content"
        name="basic"
        // initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={16}>
          {/* Ngày đăng ký tiêm */}
          <Col className="gutter-row" md={12} sm={24}>
            <Form.Item label="Ngày đăng kí tiêm" name="date">
              <RangePicker
                className="w-100"
                placeholder={["Từ ngày", "Đến ngày"]}
                format="DD/MM/YYYY"
                onChange={onChange}
                onOk={onOk}
                size="large"
              />
            </Form.Item>
          </Col>

          {/* Ngày xác nhận tiêm */}

          <Col className="gutter-row" md={12} sm={24}>
            <Form.Item
              label="
              Ngày xác nhận tiêm"
              name="date_verify"
            >
              <RangePicker
                className="w-100"
                placeholder={["Từ ngày", "Đến ngày"]}
                format="DD/MM/YYYY"
                onChange={onChange}
                onOk={onOk}
                size="large "
              />
            </Form.Item>
          </Col>
          {/* Tên phòng bệnh tương ứng */}

          <Col className="gutter-row" md={12} sm={24}>
            <Form.Item label="Tên phòng bệnh tương ứng" name="vaccine_id">
              <Select
                placeholder="Kháng nguyên"
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.className
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                allowClear
                size="large"
              >
                {vaccines &&
                  vaccines.map((item, index) => (
                    <Select.Option
                      key={index}
                      value={item.id}
                      className={item.name_pathogen}
                    >
                      {item.name_pathogen}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          {/* Trạng thái đăng ký */}

          <Col className="gutter-row" md={12} sm={24}>
            <Form.Item label="Trạng thái đăng ký" name="status_register">
              <Select placeholder="Trạng thái đăng ký" allowClear size="large">
                <Select.Option value={0}>Chờ thanh toán</Select.Option>
                <Select.Option value={1}>Chờ xác nhận ngày tiêm</Select.Option>
                <Select.Option value={2}>Đăng ký thành công</Select.Option>
                <Select.Option value={3}>Đã tiêm</Select.Option>
                {/* <Select.Option value={4}>Đã hủy</Select.Option> */}
              </Select>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={24}>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                className="mr-3"
              >
                Tìm kiếm
              </Button>
              <Button
                type="primary"
                size="large"
                htmlType="reset"
                onClick={handleReset}
              >
                Làm mới
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
export default FormSearch;
